import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as moment from 'moment';
import { StudentAccess } from '../constants/constants';
import { ParentChildrenService } from './parent-children.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  userName = new BehaviorSubject<string>(
    localStorage['userName'] ? localStorage['userName'] : ''
  );

  fullName = new BehaviorSubject<string>(
    localStorage['fullName'] ? localStorage['fullName'] : ''
  );

  userRole = new BehaviorSubject<string>(localStorage['roleId'] || '');

  studentAccess = new BehaviorSubject<StudentAccess>({
    academic: localStorage['haveAcademicCoaching']
      ? JSON.parse(localStorage['haveAcademicCoaching'])
      : false,
    testPrep: localStorage['haveTestPrep']
      ? JSON.parse(localStorage['haveTestPrep'])
      : false,
    package: localStorage.getItem('!!havePackage')
      ? JSON.parse(localStorage['!!havePackage'])
      : false,
  });

  subTopicId = new BehaviorSubject<number>(0);

  subTopicProgressId = new BehaviorSubject<string>('');

  subTopicObj = new BehaviorSubject<any>({});

  isSideBarCollapsed = new BehaviorSubject<boolean>(false);

  constructor(private parentChildrenService: ParentChildrenService) {
    if (localStorage['roleId'] === '4') {
      let selectedChild = JSON.parse(localStorage['selectedChild']) || null;
      if (!selectedChild) {
        const children = JSON.parse(localStorage['children'] || '[]');
        if (children.length > 0) {
          const childIndex = Number(localStorage['childIndex']) || 0;
          selectedChild = children[childIndex];
          localStorage['childIndex'] = childIndex.toString();
        }
      }
      if (selectedChild) {
        this.setStudentAccess({
          academic: selectedChild.haveAcademicCoaching,
          testPrep: selectedChild.haveTestPrep,
          package: selectedChild.havePackage,
        });
      }
    }
  }

  // ** Methods for getting and setting the state of sideBarCollapsedView

  getSideBarCollapsedState(): Observable<boolean> {
    return this.isSideBarCollapsed.asObservable();
  }

  setSideBarCollapsedState(state: boolean) {
    this.isSideBarCollapsed.next(state);
  }

  // Methods for Setting and getting Username

  setUserName(name: string) {
    this.userName.next(name);
  }

  getUserName(): Observable<string> {
    return this.userName.asObservable();
  }

  setFullName(name: string) {
    this.fullName.next(name);
  }

  getFullName(): Observable<string> {
    return this.fullName.asObservable();
  }

  // Methods for Setting and getting User roles

  setUserRole(role: string) {
    this.userRole.next(role);
  }

  getUserRole(): Observable<string> {
    return this.userRole.asObservable();
  }

  // Methods for Setting and getting student access

  setStudentAccess(studentAccess: StudentAccess) {
    this.studentAccess.next(studentAccess);
  }

  getStudentAccess(): Observable<StudentAccess> {
    return this.studentAccess.asObservable();
  }

  // Methods for setting and getting SubTopicId

  setSubTopicId(id: number) {
    this.subTopicId.next(id);
  }

  getSubTopicId(): Observable<number> {
    return this.subTopicId.asObservable();
  }

  // ** Methods for getting subTopicArray

  setSubTopicObj(subTopicObj: any) {
    this.subTopicObj.next(subTopicObj);
  }

  getSubTopicObj(): Observable<any> {
    return this.subTopicObj.asObservable();
  }

  // ** Methods for getting subTopic Progress ID

  setSubTopicProgressId(progressId: string) {
    this.subTopicProgressId.next(progressId);
  }

  getSubTopicProgressId(): Observable<string> {
    return this.subTopicProgressId.asObservable();
  }

  // Method for getting Date

  getDate(date: any): any {
    if (moment(date).format('MMMM DD, YYYY') !== 'Invalid date') {
      return moment(date).format('MMMM DD, YYYY');
    } else {
      return moment(date, 'DD-MM-YYYY').format('MMMM DD, YYYY');
    }
  }

  // Getting Headers
  getHeaders(): { headers: { Authorization: string } } {
    return {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken'],
      },
    };
  }

  logout() {
    localStorage.clear();
    this.parentChildrenService.setChildren([]);
    this.parentChildrenService.setChildrenLoading(false);
    this.parentChildrenService.setSelectedChildren('0');
    window.location.replace(environment.baseUrl);
  }
}
